module.exports = __webpack_public_path__ + "/static/images/assist-logo.png";